const KEYWORD_GROUPS = {
  currentAssets: [
    'cash', 'nakit', 'bank', 'receivable', 'alacak', 'inventory', 'stok', 'prepaid', 'prepayment',
    'advance', 'avans', 'contract asset', 'current tax', 'short term', 'short-term', 'other current'
  ],
  nonCurrentAssets: [
    'property', 'plant', 'equipment', 'ppe', 'maddi', 'intangible', 'maddi olmayan', 'yatirim amacli',
    'investment property', 'right-of-use', 'kullanim hakki', 'deferred tax', 'ertelenmis vergi',
    'uzun vadeli', 'long term', 'long-term', 'financial asset', 'subsidiary', 'associate'
  ],
  currentLiabilities: [
    'trade payable', 'ticari borc', 'current tax', 'tax payable', 'short term', 'short-term',
    'kisa vadeli', 'employee benefit', 'contract liability', 'accrued', 'provision current'
  ],
  nonCurrentLiabilities: [
    'long term', 'long-term', 'uzun vadeli', 'lease liability', 'deferred tax liability',
    'ertelenmis vergi', 'employee benefit obligation', 'kidem', 'provision non-current'
  ]
};

const SECTION_LABELS = {
  tr: {
    reportTitle: 'Finansal Durum Tablosu',
    statementName: 'IFRS Finansal Durum Tablosu',
    assets: 'VARLIKLAR',
    liabilitiesAndEquity: 'YUKUMLULUKLER VE OZKAYNAKLAR',
    currentAssets: 'Donen Varliklar',
    nonCurrentAssets: 'Duran Varliklar',
    currentLiabilities: 'Kisa Vadeli Yukumlulukler',
    nonCurrentLiabilities: 'Uzun Vadeli Yukumlulukler',
    equity: 'Ozkaynaklar',
    totalAssets: 'TOPLAM VARLIKLAR',
    totalLiabilities: 'TOPLAM YUKUMLULUKLER',
    totalEquity: 'TOPLAM OZKAYNAKLAR',
    totalLiabilitiesAndEquity: 'TOPLAM YUKUMLULUKLER VE OZKAYNAKLAR',
    lineItem: 'Finansal Durum Kalemi',
    noteRef: 'Dipnot Ref.',
    currentPeriod: 'Cari Donem',
    previousPeriod: 'Onceki Donem',
    noComparative: 'Karsilastirmali onceki donem verisi bulunamadi.',
    basisNote: 'Sunum, IAS 1 kapsamindaki current/non-current ayrimina gore olusturuldu.'
  },
  en: {
    reportTitle: 'Statement of Financial Position',
    statementName: 'IFRS Statement of Financial Position',
    assets: 'ASSETS',
    liabilitiesAndEquity: 'LIABILITIES AND EQUITY',
    currentAssets: 'Current Assets',
    nonCurrentAssets: 'Non-current Assets',
    currentLiabilities: 'Current Liabilities',
    nonCurrentLiabilities: 'Non-current Liabilities',
    equity: 'Equity',
    totalAssets: 'TOTAL ASSETS',
    totalLiabilities: 'TOTAL LIABILITIES',
    totalEquity: 'TOTAL EQUITY',
    totalLiabilitiesAndEquity: 'TOTAL LIABILITIES AND EQUITY',
    lineItem: 'Statement Line Item',
    noteRef: 'Note Ref.',
    currentPeriod: 'Current Period',
    previousPeriod: 'Previous Period',
    noComparative: 'No comparative previous-period data was found.',
    basisNote: 'Presentation follows IAS 1 current/non-current classification.'
  }
};

const LINE_LABELS_EN = {
  CASH_AND_EQUIVALENTS: 'Cash and Cash Equivalents',
  MARKETABLE_SECURITIES: 'Marketable Securities',
  TRADE_RECEIVABLES_CURRENT: 'Trade Receivables',
  OTHER_RECEIVABLES_CURRENT: 'Other Receivables (Current)',
  INVENTORIES: 'Inventories',
  OTHER_CURRENT_ASSETS_A: 'Prepaid Expenses',
  OTHER_CURRENT_ASSETS_B: 'Other Current Assets',
  OTHER_CURRENT_ASSETS: 'Other Current Assets',
  LONG_TERM_FINANCIAL_INV: 'Long-Term Financial Investments',
  LONG_TERM_RECEIVABLES: 'Long-Term Receivables',
  PPE: 'Property, Plant and Equipment',
  INTANGIBLES: 'Intangible Assets',
  OTHER_NON_CURRENT_ASSETS: 'Other Non-Current Assets',
  ROU_ASSET: 'Right-of-Use Assets',
  DEFERRED_TAX_ASSET: 'Deferred Tax Asset',
  SHORT_TERM_BORROWINGS: 'Short-Term Borrowings',
  TRADE_PAYABLES_CURRENT: 'Trade Payables (Current)',
  OTHER_PAYABLES_CURRENT: 'Other Payables (Current)',
  ADVANCES_RECEIVED: 'Advances Received',
  PROVISIONS_CURRENT: 'Provisions (Current)',
  OTHER_CURRENT_LIABILITIES: 'Other Current Liabilities',
  LEASE_LIABILITY_CURRENT: 'Lease Liability (Current)',
  LONG_TERM_BORROWINGS: 'Long-Term Borrowings',
  SEVERANCE_PROVISION: 'Employee Termination Benefit Provision',
  LONG_TERM_PAYABLES: 'Long-Term Payables',
  OTHER_NON_CURRENT_LIABILITIES: 'Other Non-Current Liabilities',
  LEASE_LIABILITY_NON_CURRENT: 'Lease Liability (Non-Current)',
  DEFERRED_TAX_LIABILITY: 'Deferred Tax Liability',
  SHARE_CAPITAL: 'Share Capital',
  CAPITAL_RESERVES: 'Capital Reserves',
  PROFIT_RESERVES: 'Profit Reserves',
  RETAINED_EARNINGS: 'Retained Earnings',
  ACCUMULATED_LOSSES: 'Accumulated Losses',
  PERIOD_PROFIT_LOSS: 'Profit or Loss for the Period',
  OTHER_EQUITY: 'Other Components of Equity',
  BALANCING_RESERVE: 'Balancing Reserve'
};

function normalizeText(value) {
  return String(value || '').trim().toLowerCase();
}

function containsAnyKeyword(value, keywords) {
  const normalized = normalizeText(value);
  return keywords.some((keyword) => normalized.includes(keyword));
}

function toAmount(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function buildLineKey(line) {
  const code = String(line?.code || '').trim();
  const name = normalizeText(line?.name);
  return code || name;
}

function displayLineName(line, isTr) {
  const code = String(line?.code || '').trim();
  if (!isTr && LINE_LABELS_EN[code]) {
    return LINE_LABELS_EN[code];
  }
  return line?.name || code || '-';
}

function inferNoteRef() {
  return '';
}

function classifyAsset(line) {
  const code = String(line?.code || '').trim();
  const name = line?.name || '';
  if (code.startsWith('1')) return 'currentAssets';
  if (code.startsWith('2')) return 'nonCurrentAssets';
  if (containsAnyKeyword(name, KEYWORD_GROUPS.currentAssets)) return 'currentAssets';
  if (containsAnyKeyword(name, KEYWORD_GROUPS.nonCurrentAssets)) return 'nonCurrentAssets';
  return 'nonCurrentAssets';
}

function classifyLiability(line) {
  const code = String(line?.code || '').trim();
  const name = line?.name || '';
  if (code.startsWith('3')) return 'currentLiabilities';
  if (code.startsWith('4')) return 'nonCurrentLiabilities';
  if (containsAnyKeyword(name, KEYWORD_GROUPS.currentLiabilities)) return 'currentLiabilities';
  if (containsAnyKeyword(name, KEYWORD_GROUPS.nonCurrentLiabilities)) return 'nonCurrentLiabilities';
  return 'currentLiabilities';
}

function determineBucket(line) {
  const type = String(line?.accountType || '').trim().toUpperCase();
  if (type === 'CURRENT_ASSETS') return 'currentAssets';
  if (type === 'NON_CURRENT_ASSETS') return 'nonCurrentAssets';
  if (type === 'CURRENT_LIABILITIES') return 'currentLiabilities';
  if (type === 'NON_CURRENT_LIABILITIES') return 'nonCurrentLiabilities';
  if (type === 'ASSET') return classifyAsset(line);
  if (type === 'LIABILITY') return classifyLiability(line);
  if (type === 'EQUITY') return 'equity';
  return null;
}

function compareRows(a, b) {
  const codeA = String(a.code || '');
  const codeB = String(b.code || '');
  if (codeA && codeB) {
    return codeA.localeCompare(codeB, undefined, { numeric: true, sensitivity: 'base' });
  }
  return String(a.name || '').localeCompare(String(b.name || ''), undefined, { sensitivity: 'base' });
}

function combineLines(currentLines, previousLines, isTr) {
  const registry = new Map();
  currentLines.forEach((line) => {
    const key = buildLineKey(line);
    const bucket = determineBucket(line);
    if (!key || !bucket) return;
    registry.set(key, {
      key,
      code: line.code || '',
      name: displayLineName(line, isTr),
      noteRef: inferNoteRef(line),
      bucket,
      currentAmount: toAmount(line.amount),
      previousAmount: 0
    });
  });

  previousLines.forEach((line) => {
    const key = buildLineKey(line);
    const bucket = determineBucket(line);
    if (!key || !bucket) return;
    const existing = registry.get(key);
    if (existing) {
      existing.previousAmount = toAmount(line.amount);
      return;
    }
    registry.set(key, {
      key,
      code: line.code || '',
      name: displayLineName(line, isTr),
      noteRef: inferNoteRef(line),
      bucket,
      currentAmount: 0,
      previousAmount: toAmount(line.amount)
    });
  });

  return [...registry.values()].sort(compareRows);
}

function sumRows(rows, amountKey) {
  return rows.reduce((total, row) => total + toAmount(row[amountKey]), 0);
}

export function formatFinancialStatementAmount(value, locale) {
  const numeric = toAmount(value);
  const hasFraction = Math.abs(numeric % 1) > 0.0001;
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: hasFraction ? 2 : 0
  }).format(numeric);
}

export function buildFinancialPositionPresentation({
  currentReport,
  previousReport,
  currentPeriodLabel,
  previousPeriodLabel,
  isTr
}) {
  const labels = isTr ? SECTION_LABELS.tr : SECTION_LABELS.en;
  const locale = isTr ? 'tr-TR' : 'en-US';
  const combinedRows = combineLines(currentReport?.lines || [], previousReport?.lines || [], isTr);
  const bucketRows = {
    currentAssets: [],
    nonCurrentAssets: [],
    currentLiabilities: [],
    nonCurrentLiabilities: [],
    equity: []
  };

  combinedRows.forEach((row) => {
    bucketRows[row.bucket].push(row);
  });

  const groups = [
    { key: 'currentAssets', section: 'assets', title: labels.currentAssets },
    { key: 'nonCurrentAssets', section: 'assets', title: labels.nonCurrentAssets },
    { key: 'currentLiabilities', section: 'liabilitiesAndEquity', title: labels.currentLiabilities },
    { key: 'nonCurrentLiabilities', section: 'liabilitiesAndEquity', title: labels.nonCurrentLiabilities },
    { key: 'equity', section: 'liabilitiesAndEquity', title: labels.equity }
  ].map((group) => {
    const rows = bucketRows[group.key];
    return {
      ...group,
      rows,
      currentTotal: sumRows(rows, 'currentAmount'),
      previousTotal: sumRows(rows, 'previousAmount')
    };
  });

  const currentAssetsTotal = groups
    .filter((group) => group.section === 'assets')
    .reduce((total, group) => total + group.currentTotal, 0);
  const previousAssetsTotal = groups
    .filter((group) => group.section === 'assets')
    .reduce((total, group) => total + group.previousTotal, 0);
  const currentLiabilitiesTotal = groups
    .filter((group) => group.key === 'currentLiabilities' || group.key === 'nonCurrentLiabilities')
    .reduce((total, group) => total + group.currentTotal, 0);
  const previousLiabilitiesTotal = groups
    .filter((group) => group.key === 'currentLiabilities' || group.key === 'nonCurrentLiabilities')
    .reduce((total, group) => total + group.previousTotal, 0);
  const currentEquityTotal = groups.find((group) => group.key === 'equity')?.currentTotal || 0;
  const previousEquityTotal = groups.find((group) => group.key === 'equity')?.previousTotal || 0;

  return {
    labels,
    locale,
    currentPeriodLabel: currentPeriodLabel || labels.currentPeriod,
    previousPeriodLabel: previousPeriodLabel || labels.previousPeriod,
    comparativeAvailable: Boolean(previousReport?.lines?.length),
    metadataNote: labels.basisNote,
    sections: [
      {
        key: 'assets',
        title: labels.assets,
        groups: groups.filter((group) => group.section === 'assets'),
        totalLabel: labels.totalAssets,
        currentTotal: currentAssetsTotal,
        previousTotal: previousAssetsTotal
      },
      {
        key: 'liabilitiesAndEquity',
        title: labels.liabilitiesAndEquity,
        groups: groups.filter((group) => group.section === 'liabilitiesAndEquity'),
        totalLabel: labels.totalLiabilitiesAndEquity,
        currentTotal: currentLiabilitiesTotal + currentEquityTotal,
        previousTotal: previousLiabilitiesTotal + previousEquityTotal
      }
    ],
    totals: {
      assets: { label: labels.totalAssets, current: currentAssetsTotal, previous: previousAssetsTotal },
      liabilities: { label: labels.totalLiabilities, current: currentLiabilitiesTotal, previous: previousLiabilitiesTotal },
      equity: { label: labels.totalEquity, current: currentEquityTotal, previous: previousEquityTotal },
      liabilitiesAndEquity: {
        label: labels.totalLiabilitiesAndEquity,
        current: currentLiabilitiesTotal + currentEquityTotal,
        previous: previousLiabilitiesTotal + previousEquityTotal
      }
    }
  };
}
